<template>
    <div class="card-wrap">
            <div v-if="isNew">
                <div class="ui-base-card" @click="$emit('onClick')">
                    <div class="ui-folder-img">
                        <img :src="newFolder" alt="folder">
                    </div>
                    <div class="text-content">
                        <p class="folder-name">新建</p>
                    </div>
                </div>
            </div>
            <div v-else-if="isData">
                <div class="ui-base-card file" @click="$emit('onClick')">
                    <div class="ui-folder-img">
                        <img :src="file" alt="file">
                    </div>
                    <div class="text-content">
                        <p class="folder-name" :title="name">{{ name }}</p>
                        <p class="folder-status">
                            <span v-if="status.submit === true">已提交</span>
                            <span v-if="status.submit === false">未提交</span>
                            <span v-if="status.down === true">已下载</span>
                            <span v-if="status.down === false">未下载</span>
                        </p>
                    </div>
                    <div class="folder-info">
                        <p v-if="dataNums || dataNums === 0">包含数据 {{ dataNums }} 份</p>
                        <p v-if="imgNums || imgNums === 0">包含图片 {{ imgNums }} 张</p>
                    </div>
                    <div class="card-bottom-group" v-if="!readOnly">
                        <div v-if="bottoms.down" class="card-bottom down" @click.stop="$emit('down')">下载</div>
                        <div v-if="bottoms.del" class="card-bottom del" @click.stop="$emit('del', row)">删除</div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="ui-base-card" @click="$emit('onClick')">
                    <div class="ui-folder-img">
                        <img :src="isInvalid ? folderGray : folder" alt="folder">
                    </div>
                    <div class="text-content">
                        <p class="folder-name" :title="name">{{ name }}</p>
                        <p class="folder-status">
                            <span v-if="status.submit === true">已提交</span>
                            <span v-if="status.submit === false">未提交</span>
                            <span v-if="status.down === true">已下载</span>
                            <span v-if="status.down === false">未下载</span>
                        </p>
                    </div>
                    <div class="folder-info">
                        <p v-if="dataNums || dataNums === 0">包含数据 {{ dataNums }} 份</p>
                        <p v-if="imgNums || imgNums === 0">包含图片 {{ imgNums }} 张</p>
                    </div>
                    <div class="card-bottom-group" v-if="!readOnly">
                        <div v-if="bottoms.modify" class="card-bottom modify" @click.stop="$emit('modify')">修改</div>
                        <div v-if="bottoms.empty" class="card-bottom empty" @click.stop="$emit('empty')">清空</div>
                        <div v-if="bottoms.down" class="card-bottom down" @click.stop="$emit('down')">下载</div>
                        <div v-if="bottoms.submit" class="card-bottom submit" @click.stop="$emit('submit')">提交</div>
                        <div v-if="bottoms.del" class="card-bottom del" @click.stop="$emit('del', row)">删除</div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        props: {
            isNew: {
                type: Boolean,
                default: false
            },
            isData: {
                type: Boolean,
                default: false
            },
            isSubmit: {
                type: Boolean,
                default: false
            },
            name: {
                type: String,
                default: ''
            },
            row: {
                type: Object,
                default: () => ({})
            },
            dataNums: {
                type: [Number, String],
                default: ''
            },
            imgNums: {
                type: [Number, String],
                default: ''
            },
            invalidTime: {
                type: String,
                default: ''
            },
            bottoms: {
                type: Object,
                default: () => ({})
            },
            status: {
                type: Object,
                default: () => ({})
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                newFolder: require('../assets/img/new-folder.png'),
                folder: require('../assets/img/folder.png'),
                folderGray: require('../assets/img/folder-gray.png'),
                file: require('../assets/img/file.png'),
            }
        },
        computed: {
            isInvalid () {
                if (!this.invalidTime) {
                    return false
                }
                return new Date(this.invalidTime).getTime() - new Date().getTime() <= 0
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss" scoped>
.card-wrap {
    display: inline-block;
}
.ui-base-card {
    margin-top: 20px;
    display: inline-block;
    position: relative;
    width: 125px;
    height: 125px;
    cursor: pointer;
    background: none;
    &:hover .card-bottom-group{
        opacity: 1;
        right: -30px;
    }
    &.file {
        width: 92px;
        height: auto;
        .folder-info {
            top: 72px;
            width: 70px;
            font-size: 12px;
        }
    }
}
.card-bottom-group {
    position: absolute;
    right: 0px;
    top: 10px;
    opacity: 0;
    transition: all .3s;
    .card-bottom {
        margin-top: 10px;
        padding: 2px 6px;
        color: #fff;
        text-align: center;
        border-radius: 8px;
        font-size: 12px;
        &.submit {
            background: #32d396;
        }
        &.down {
            background: #1e87f0;
        }
        &.del {
            background: #ff7272;
        }
        &.modify {
            background: #faa05a;
        }
        &.empty {
            background: #ff7272;
        }
    }
}
.ui-folder-img {
    width: 100%;
    height: 100%;
    overflow: hidden;
    img {
        width: 100%;
        height: 100%;
    }
}

.text-content {
    margin-top: -10px;
    text-align: center;
    .folder-name {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }
    .folder-status {
        color: #888888;
        font-size: 14px;
        & > span:not(:first-child) {
            margin-left: 10px;
        }
    }
}
.folder-info {
    position: absolute;
    left: 6px;
    top: 78px;
    color: #ffffff;
    opacity: .7;
    font-size: 12px;
    .invalid {
        color: #ff7272;
    }
}
</style>